<template>
  <div class="table-footer">
    <div class="footer-left">
      <!-- <div v-if="showCheckMore" :id="'check-more'" class="icon" @click="checkMore">
        <svg-icon name="list"></svg-icon>
        <span>批量</span>
      </div> -->
      <slot name="other-btns"></slot>
      <div v-if="showAnalyse" :id="'analyse'" class="icon" @click="analyse">
        <svg-icon :id="'analyse-icon'" name="area_chart"></svg-icon>
        <span :id="'analyse-span'">{{ $t("tableComponent.analysis") }}</span>
      </div>
      <div v-if="showDownload" class="icon" @click="download">
        <svg-icon name="download"></svg-icon>
        <span>{{$t("tableComponent.download") }}</span>
      </div>
      <el-input v-if="showSearch" class="search" size="mini" :placeholder="searchPlaceholder" @keyup.enter.native="changeSearch" :maxlength="100" v-model="keyword">
        <i @click="changeSearch" slot="suffix" class="el-input__icon el-icon-search"></i>
      </el-input>
    </div>
    <div class="page">
       <!-- :class="total/pageSize > 5?'hide-last':''" -->
       <div  :class="showLastNum&&(total/pageSize)>1000?'showLastNumStyle':''">
      <el-pagination 
          v-if="showPage" size="mini" @size-change="changeSize" @current-change="changePage" :current-page="pageIndex" :page-sizes="[10, 20, 30, 50, 100]" :page-size="pageSize" :layout="pageLayout" :total="total">
      </el-pagination>
       </div>
      <!-- <span>{{$t("tableComponent.total")}}{{Math.ceil(total/pageSize)}}{{ $t("tableComponent.strip") }}</span> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'tableFooter',
  props: {
    pageIndex: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    },
    total: {
      type: Number,
      default: 0
    },
    showCheckMore: {
      type: Boolean,
      default: false
    },
    showLastNum:{
      type:Boolean,
      default:false
    },
    showSearch: {
      type: Boolean,
      default: false
    },
    showAnalyse: {
      type: Boolean,
      default: false
    },
    showDownload: {
      type: Boolean,
      default: false
    },
    searchPlaceholder: {
      type: String,
      default: '输入关键词进行搜索'
    },
    showPage: {
      type: Boolean,
      default: true
    },
    showPageSize: {
      type: Boolean,
      default: true
    },
    layout: {
      type: String
    },
  },
  data() {
    return {
      keyword: '',
    }
  },
  created() {
  },
  methods: {
    changeSize(val) {
      this.$emit('change-page-size', val)
    },
    changePage(val) {
      this.$emit('change-page', val,this.pageSize)
    },
    checkMore(){
      this.$emit('check-more')
    },
    download() {
      this.$emit('download')
    },
    analyse() {
      this.$emit('analyse')
    },
    changeSearch() {
      this.$emit('change-search', this.keyword)
    }
  },
  computed:{
    pageLayout() {
      return this.layout ? this.layout : this.showPageSize ? 'total, sizes, prev, pager, next' : 'total, prev, pager, next'
    }
  }
}
</script>

<style lang="scss" scoped>
//  .showLastNumStyle {
 .showLastNumStyle /deep/ .el-pager{
    li:nth-last-child(1){
     display: none!important;
    }
  }
// }
.table-footer {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  align-items: center;
  height: 30px;
  &.hide-search {
    justify-content: flex-end;
  }
  /deep/.search {
    width: 250px;
    .el-icon-search {
      cursor: pointer;
    }
  }
  .footer-left {
    display: flex;
    flex-direction: row;
    align-items: center;
    .icon {
      margin-right: 10px;
      height: 19px;
      cursor: pointer;
      .svg-icon {
        font-size: 18px;
      }
    }
  }
  .page{
    display: flex;
    align-items: center;
    font-size: 13px;
  }
  /deep/.el-pagination{
    height: 28px;
    button,li{
      background-color: transparent
    }
    &.hide-last{
      .el-pager{
        .number{
          &:last-of-type{
            display: none;
          }
          // &:nth-of-type(5){
          //   display: inline-block;
          // }
        }
      }
    }
    
  }
}
</style>
